namespace $.$$ {
	$mol_style_define( $shm_projects_module_card, {
		flex: { direction: 'column' },
		background: { color: $mol_theme.card },
		border: { radius: $mol_gap.round },
		overflowWrap: 'anywhere',
	} )
}
